var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{class:_vm.styleClass,attrs:{"size":_vm.size}},[_c('v-icon',{attrs:{"size":_vm.iconSize,"color":"primary"}},[_vm._v(_vm._s(_vm.iconMapping('person')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }